import React from "react";
import {gql} from "@apollo/client";
import DeviceStatisticTemplate from "./DeviceStatisticTemplate";
import {formatToLocalTime} from "../utils/dateUtils";
import {useTranslation} from "react-i18next";
import ShowChartIcon from "@mui/icons-material/ShowChart";

const PAGINATE_AKIFERRA_STAT = gql`
    query PaginateAkiferraStatistic($pagination: Pagination!, $sortBy: [SortBy!], $criteria: DeviceAkiferraStatisticCriteria) {
        paginateDeviceAkiferraStatistic(pagination: $pagination, sortBy: $sortBy, criteria: $criteria) {
            pageInfo {
                totalElements
                totalPages
                numberOfElements
                pageNumber
                pageSize
            }
            content {
                id
                serialNumber
                locationName
                customerName
                resellerName
                timestamp
                updatedTimestamp
                roomTempWaterVolume
                coldTempWaterVolume
                sparklingWaterVolume
                roomTempWaterSmallBottleCount
                roomTempWaterLargeBottleCount
                coldTempWaterSmallBottleCount
                coldTempWaterLargeBottleCount
                sparklingWaterSmallBottleCount
                sparklingWaterLargeBottleCount
            }
        }
    }
`;

export default function AkiferraStatistic() {
    const {t} = useTranslation();

    const columns = [
        {field: "serialNumber", label: t("stats.serial"), sortable: true},
        {field: "resellerName", label: t("stats.reseller"), sortable: true},
        {field: "customerName", label: t("stats.customer"), sortable: true},
        {field: "locationName", label: t("stats.location"), sortable: true},

        // {
        //   field: "updatedTimestamp",
        //   label: t("stats.updated"),
        //   sortable: true,
        //   format: (v) => (v ? formatToLocalTime(v) : t("common.notAvailable")),
        // },
        {field: "roomTempWaterVolume", label: t("stats.roomTempVol")},
        {field: "coldTempWaterVolume", label: t("stats.coldVol")},
        {field: "sparklingWaterVolume", label: t("stats.sparklingVol")},
        {field: "roomTempWaterSmallBottleCount", label: t("stats.roomSmallBottles")},
        {field: "roomTempWaterLargeBottleCount", label: t("stats.roomLargeBottles")},
        {field: "coldTempWaterSmallBottleCount", label: t("stats.coldSmallBottles")},
        {field: "coldTempWaterLargeBottleCount", label: t("stats.coldLargeBottles")},
        {field: "sparklingWaterSmallBottleCount", label: t("stats.sparkSmallBottles")},
        {field: "sparklingWaterLargeBottleCount", label: t("stats.sparkLargeBottles")},
        {
            field: "timestamp",
            label: t("stats.timestamp"),
            sortable: true,
            format: (v) => (v ? formatToLocalTime(v) : t("common.notAvailable")),
            nowrap: true,
            sticky: "right",
            width: 180,
        }
    ];

    return (
        <DeviceStatisticTemplate
            title={t("akiferraStatistics.title")}
            subtitle={t("akiferraStatistics.subtitle")}
            query={PAGINATE_AKIFERRA_STAT}
            columns={columns}
            icon={<ShowChartIcon/>}
        />
    );
}
